const TENANT_NAME = "munshify";

export const updateTenant = (url: string): string => url;

export const getTenantName = (_url?: string) => TENANT_NAME;
